(() => {
  if (window.BLGLinkedTabs) {
    window.BLGLinkedTabs.init();
    return;
  }

  const SECTION_SELECTOR = '[data-blg-linked-tabs-section]';
  const TRIGGER_SELECTOR = '[data-blg-linked-tabs-trigger]';
  const state = {};

  const toArray = items => Array.from(items || []);
  const sectionTarget = section => section.closest('[id^="shopify-section-"]') || section;

  const groupSections = group => toArray(document.querySelectorAll(SECTION_SELECTOR))
    .filter(section => section.dataset.blgLinkedTabsGroup === group);

  const groupTriggers = group => toArray(document.querySelectorAll(TRIGGER_SELECTOR))
    .filter(trigger => trigger.dataset.blgLinkedTabsGroup === group);

  const groups = () => {
    const names = new Set();

    toArray(document.querySelectorAll(SECTION_SELECTOR)).forEach(section => {
      if (section.dataset.blgLinkedTabsGroup) {
        names.add(section.dataset.blgLinkedTabsGroup);
      }
    });

    toArray(document.querySelectorAll(TRIGGER_SELECTOR)).forEach(trigger => {
      if (trigger.dataset.blgLinkedTabsGroup) {
        names.add(trigger.dataset.blgLinkedTabsGroup);
      }
    });

    return Array.from(names);
  };

  const firstDefaultPanel = group => {
    const defaultSection = groupSections(group).find(section =>
      section.dataset.blgLinkedTabsDefault === 'true' && section.dataset.blgLinkedTabsPanel
    );

    if (defaultSection) {
      return defaultSection.dataset.blgLinkedTabsPanel;
    }

    const firstTrigger = groupTriggers(group).find(trigger => trigger.dataset.blgLinkedTabsPanel);

    if (firstTrigger) {
      return firstTrigger.dataset.blgLinkedTabsPanel;
    }

    const firstSection = groupSections(group).find(section => section.dataset.blgLinkedTabsPanel);

    return firstSection ? firstSection.dataset.blgLinkedTabsPanel : '';
  };

  const isVisible = element =>
    !!element && !element.closest('[hidden]') && element.getClientRects().length > 0;

  const focusActiveTrigger = (group, panel) => {
    const trigger = groupTriggers(group).find(item =>
      item.dataset.blgLinkedTabsPanel === panel && isVisible(item)
    );

    trigger?.focus({ preventScroll: true });
  };

  const applyPanel = (group, panel, options = {}) => {
    if (!group || !panel) {
      return;
    }

    state[group] = panel;

    groupSections(group).forEach(section => {
      const active = section.dataset.blgLinkedTabsPanel === panel;
      const target = sectionTarget(section);

      target.hidden = !active;
      target.setAttribute('aria-hidden', active ? 'false' : 'true');
    });

    groupTriggers(group).forEach(trigger => {
      const active = trigger.dataset.blgLinkedTabsPanel === panel;

      trigger.classList.toggle('is-active', active);
      trigger.setAttribute('aria-selected', active ? 'true' : 'false');
      trigger.setAttribute('aria-pressed', active ? 'true' : 'false');
      trigger.tabIndex = active ? 0 : -1;
    });

    document.dispatchEvent(new CustomEvent('blg:linked-tabs:change', {
      detail: {
        group,
        panel
      }
    }));

    requestAnimationFrame(() => {
      window.dispatchEvent(new Event('resize'));

      if (options.focus) {
        focusActiveTrigger(group, panel);
      }
    });
  };

  const onTriggerClick = event => {
    const { blgLinkedTabsGroup, blgLinkedTabsPanel } = event.currentTarget.dataset;

    applyPanel(blgLinkedTabsGroup, blgLinkedTabsPanel, {
      focus: true
    });
  };

  const onTriggerKeydown = event => {
    const keys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];

    if (!keys.includes(event.key)) {
      return;
    }

    const trigger = event.currentTarget;
    const tablist = trigger.closest('[role="tablist"]');

    if (!tablist) {
      return;
    }

    const triggers = toArray(tablist.querySelectorAll(TRIGGER_SELECTOR)).filter(isVisible);
    const currentIndex = triggers.indexOf(trigger);
    let nextIndex = currentIndex;

    if (event.key === 'Home') {
      nextIndex = 0;
    } else if (event.key === 'End') {
      nextIndex = triggers.length - 1;
    } else if (event.key === 'ArrowRight') {
      nextIndex = currentIndex + 1 >= triggers.length ? 0 : currentIndex + 1;
    } else if (event.key === 'ArrowLeft') {
      nextIndex = currentIndex - 1 < 0 ? triggers.length - 1 : currentIndex - 1;
    }

    const nextTrigger = triggers[nextIndex];

    if (nextTrigger) {
      const { blgLinkedTabsGroup, blgLinkedTabsPanel } = nextTrigger.dataset;

      event.preventDefault();
      applyPanel(blgLinkedTabsGroup, blgLinkedTabsPanel, {
        focus: true
      });
    }
  };

  const bindTriggers = () => {
    toArray(document.querySelectorAll(TRIGGER_SELECTOR)).forEach(trigger => {
      if (trigger.dataset.blgLinkedTabsBound === 'true') {
        return;
      }

      trigger.dataset.blgLinkedTabsBound = 'true';
      trigger.addEventListener('click', onTriggerClick);
      trigger.addEventListener('keydown', onTriggerKeydown);
    });
  };

  const init = () => {
    bindTriggers();

    groups().forEach(group => {
      applyPanel(group, state[group] || firstDefaultPanel(group), {
        focus: false
      });
    });
  };

  const revealSelectedShopifySection = event => {
    if (!event.detail?.sectionId) {
      return;
    }

    const shopifySection = document.getElementById(`shopify-section-${event.detail.sectionId}`);
    const section = shopifySection?.querySelector(SECTION_SELECTOR);

    if (section?.dataset.blgLinkedTabsGroup && section.dataset.blgLinkedTabsPanel) {
      applyPanel(section.dataset.blgLinkedTabsGroup, section.dataset.blgLinkedTabsPanel, {
        focus: false
      });
    }
  };

  window.BLGLinkedTabs = {
    init,
    show: applyPanel
  };

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', revealSelectedShopifySection);

  init();
})();
